/* eslint-disable react/prop-types */
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, Divider, Grid, IconButton, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import styles from './styles';
import FileUploadDialog from '../../ui/FileUploadDialog';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { enqueueSnackbar } from '../../../store/actions/snackbar';
import { CancelPresentationRounded } from '@mui/icons-material';
import { importDrillStringJsonFile } from '../../../store/actions/wellsDrillString';
import { HYDRAULICS_MAX_FILE_SIZE } from '../../../utils/constants';

const DrillStringConfirmationModal = ({ open, handleClose, importRow }) => {
  const classes = styles();
  const dispatch = useDispatch();
  const [uploadOpen, setUploadOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleUploadSuccess = () => {
    handleClose(false);
    dispatch(
      enqueueSnackbar(
        'DrillString Data Uploaded Successfully',
        'success',
        new Date().getTime() + Math.random()
      )
    );
  };

  const handleUploadJson = (selectedFile) => {
    if (selectedFile.size >= HYDRAULICS_MAX_FILE_SIZE.ONE_MB_BYTE) {
      dispatch(
        enqueueSnackbar(
          'File must be less than 1 MB ',
          'error',
          new Date().getTime() + Math.random()
        )
      );
    } else {
      dispatch(importDrillStringJsonFile(selectedFile, importRow?._id, importRow?.wellsInfoId, setIsLoading, handleUploadSuccess));
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={() => {
          handleClose(false);
        }}
        fullWidth={true}
        className={classes.dialogModal}
      >
        <Box className={classes.dialogTitle}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '1.3rem' }}>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item>Attention!</Grid>
              <Grid item>
                <IconButton
                  onClick={() => {
                    handleClose(false);
                  }}
                >
                  <CancelPresentationRounded fontSize='large' />
                </IconButton>
              </Grid>
            </Grid>
          </Typography>
        </Box>
        <Divider />
        <DialogContent>
          <DialogContentText align='center' style={{ marginLeft: '-0.7rem' }} color={'black'} fontSize={'18px'} fontWeight='bold' id="alert-dialog-description">
          Existing Drillstring data will be lost
          </DialogContentText>
        </DialogContent>
        <Grid container item justifyContent='center' marginBottom='2rem'>
          <DialogActions>
            <Button
              style={{ backgroundColor: '#444', width: '100px' }}
              onClick={() => {
                setUploadOpen(true);
              }}
            >
              Continue
            </Button>
          </DialogActions>
        </Grid>
      </Dialog>
      <FileUploadDialog
          open={uploadOpen}
          handleClose={() => {
            setUploadOpen(false);
            handleClose(false);
          }}
          handleUpload={handleUploadJson}
          fileSize={HYDRAULICS_MAX_FILE_SIZE.ONE_MB}
          type={'json'}
          isLoading = {isLoading}
        />
    </React.Fragment>
  );
};

DrillStringConfirmationModal.propTypes = {
  open: PropTypes.any,
  handleClose: PropTypes.any,
  importRow: PropTypes.any
};

export default DrillStringConfirmationModal;
